<!-- <div class="change-password-page">
  <div class="change-password-card">

    <div class="page-header">
      <div class="header-icon">
        <i class="bi bi-shield-lock"></i>
      </div>

      <h2>Change Password</h2>
      <p>Update your password to keep your account secure.</p>
    </div>

    <form
      [formGroup]="changePasswordForm"
      (ngSubmit)="onSubmit()"
      novalidate
    >

      <div class="form-field">
        <label class="form-label" for="oldPassword">
          Old Password
        </label>

        <div class="input-shell">
          <i class="bi bi-lock input-icon" aria-hidden="true"></i>

          <input
            id="oldPassword"
            [type]="showOldPassword ? 'text' : 'password'"
            formControlName="oldPassword"
            class="form-control"
            [ngClass]="{
              'is-invalid': submitted && f['oldPassword'].errors,
              'is-valid': submitted && !f['oldPassword'].errors
            }"
            placeholder="Enter old password"
            autocomplete="current-password"
          />

          <button
            type="button"
            class="password-toggle"
            (click)="togglePassword('old')"
            [attr.aria-label]="
              showOldPassword ? 'Hide old password' : 'Show old password'
            "
          >
            <i
              class="bi"
              [class.bi-eye]="!showOldPassword"
              [class.bi-eye-slash]="showOldPassword"
              aria-hidden="true"
            ></i>
          </button>
        </div>

        <div
          class="invalid-feedback"
          [class.d-block]="submitted && f['oldPassword'].errors"
        >
          <div *ngIf="f['oldPassword'].errors?.['required']">
            Old password is required
          </div>

          <div *ngIf="f['oldPassword'].errors?.['minlength']">
            Minimum 6 characters required
          </div>
        </div>
      </div>


      <div class="form-field">
        <label class="form-label" for="newPassword">
          New Password
        </label>

        <div class="input-shell">
          <i class="bi bi-lock input-icon" aria-hidden="true"></i>

          <input
            id="newPassword"
            [type]="showNewPassword ? 'text' : 'password'"
            formControlName="newPassword"
            class="form-control"
            [ngClass]="{
              'is-invalid': submitted && f['newPassword'].errors,
              'is-valid': submitted && !f['newPassword'].errors
            }"
            placeholder="Enter new password"
            autocomplete="new-password"
          />

          <button
            type="button"
            class="password-toggle"
            (click)="togglePassword('new')"
            [attr.aria-label]="
              showNewPassword ? 'Hide new password' : 'Show new password'
            "
          >
            <i
              class="bi"
              [class.bi-eye]="!showNewPassword"
              [class.bi-eye-slash]="showNewPassword"
              aria-hidden="true"
            ></i>
          </button>
        </div>

        <div
          class="invalid-feedback"
          [class.d-block]="submitted && f['newPassword'].errors"
        >
          <div *ngIf="f['newPassword'].errors?.['required']">
            New password is required
          </div>

          <div *ngIf="f['newPassword'].errors?.['minlength']">
            Minimum 6 characters required
          </div>

          <div *ngIf="f['newPassword'].errors?.['maxlength']">
            Maximum 20 characters allowed
          </div>

          <div *ngIf="f['newPassword'].errors?.['pattern']">
            Password must contain at least one uppercase letter, one lowercase
            letter, one number and one special character
          </div>

          <div *ngIf="f['newPassword'].errors?.['sameAsOld']">
            New password must be different from old password
          </div>
        </div>
      </div>


      <div class="form-field">
        <label class="form-label" for="confirmPassword">
          Confirm Password
        </label>

        <div class="input-shell">
          <i class="bi bi-lock-fill input-icon" aria-hidden="true"></i>

          <input
            id="confirmPassword"
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmPassword"
            class="form-control"
            [ngClass]="{
              'is-invalid':
                submitted &&
                (f['confirmPassword'].errors || changePasswordForm.errors?.['passwordMismatch']),
              'is-valid':
                submitted &&
                !f['confirmPassword'].errors &&
                !changePasswordForm.errors?.['passwordMismatch']
            }"
            placeholder="Confirm new password"
            autocomplete="new-password"
          />

          <button
            type="button"
            class="password-toggle"
            (click)="togglePassword('confirm')"
            [attr.aria-label]="
              showConfirmPassword
                ? 'Hide confirm password'
                : 'Show confirm password'
            "
          >
            <i
              class="bi"
              [class.bi-eye]="!showConfirmPassword"
              [class.bi-eye-slash]="showConfirmPassword"
              aria-hidden="true"
            ></i>
          </button>
        </div>

        <div
          class="invalid-feedback"
          [class.d-block]="
            submitted &&
            (f['confirmPassword'].errors ||
              changePasswordForm.errors?.['passwordMismatch'])
          "
        >
          <div *ngIf="f['confirmPassword'].errors?.['required']">
            Confirm password is required
          </div>

          <div *ngIf="f['confirmPassword'].errors?.['minlength']">
            Minimum 6 characters required
          </div>

          <div
            *ngIf="
              !f['confirmPassword'].errors?.['required'] &&
              changePasswordForm.errors?.['passwordMismatch']
            "
          >
            Passwords do not match
          </div>
        </div>
      </div>


      <div class="button-section">

        <button
          type="button"
          class="btn btn-light cancel-btn"
          (click)="goBack()"
          [disabled]="isLoading"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="btn login-submit"
          [disabled]="isLoading"
        >
          <span
            *ngIf="isLoading"
            class="spinner-border spinner-border-sm me-2"
            aria-hidden="true"
          ></span>

          <i
            *ngIf="!isLoading"
            class="bi bi-key me-2"
            aria-hidden="true"
          ></i>

          {{ isLoading ? 'Updating...' : 'Change Password' }}
        </button>

      </div>

    </form>
  </div>
</div> -->



<!-- Change Password Modal -->
<div class="change-password-overlay" *ngIf="showChangePasswordModal" role="dialog" aria-modal="true"
  aria-labelledby="changePasswordTitle">
  <div class="change-password-modal">

    <div class="change-password-header">
      <div class="header-icon">
        <i class="bi bi-shield-lock"></i>
      </div>

      <h2 id="changePasswordTitle">Change Password</h2>

      <p>
        @if (optional) {
          Choose a new password for your account.
        } @else {
          For security reasons, you must change your password before continuing.
        }
      </p>
    </div>
    <span class="text-muted mt-2 d-block text-center" *ngIf="isError">
      <b class="text-dabger">{{err.error.message}}</b>
    </span>
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" novalidate>

      <!-- Old Password -->
      <!-- <div class="form-field">
        <label class="form-label" for="oldPassword">
          Old Password
        </label> -->

      <!-- <div class="input-shell">
          <i class="bi bi-lock input-icon"></i>

          <input id="oldPassword" [type]="showOldPassword ? 'text' : 'password'" formControlName="oldPassword"
            class="form-control" [ngClass]="{
              'is-invalid': passwordSubmitted && f['oldPassword'].errors,
              'is-valid': passwordSubmitted && !f['oldPassword'].errors
            }" placeholder="Enter old password" autocomplete="current-password" />

          <button type="button" class="password-toggle" (click)="togglePassword('old')">
            <i class="bi" [class.bi-eye]="!showOldPassword" [class.bi-eye-slash]="showOldPassword"></i>
          </button>
        </div> -->

      <!-- <div class="invalid-feedback" [class.d-block]="passwordSubmitted && f['oldPassword'].errors">
          <div *ngIf="f['oldPassword'].errors?.['required']">
            Old password is required
          </div>

          <div *ngIf="f['oldPassword'].errors?.['minlength']">
            Minimum 8 characters required
          </div>
        </div>
      </div> -->


      <!-- New Password -->
      <div class="form-field">
        <label class="form-label" for="newPassword">
          New Password <span class="text-muted">(must be at least 8 characters, include uppercase, lowercase, number and
            special character)</span>
        </label>

        <div class="input-shell">
          <i class="bi bi-lock input-icon"></i>

          <input id="newPassword" [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
            class="form-control" [ngClass]="{
              'is-invalid': passwordSubmitted && f['newPassword'].errors,
              'is-valid': passwordSubmitted && !f['newPassword'].errors
            }" placeholder="Enter new password" autocomplete="new-password" />

          <button type="button" class="password-toggle" (click)="togglePassword('new')">
            <i class="bi" [class.bi-eye]="!showNewPassword" [class.bi-eye-slash]="showNewPassword"></i>
          </button>
        </div>

        <div class="invalid-feedback" [class.d-block]="passwordSubmitted && f['newPassword'].errors">
          <div *ngIf="f['newPassword'].errors?.['required']">
            New password is required
          </div>

          <div *ngIf="f['newPassword'].errors?.['minlength']">
            Minimum 8 characters required
          </div>

          <div *ngIf="f['newPassword'].errors?.['maxlength']">
            Maximum 20 characters allowed
          </div>

          <div *ngIf="f['newPassword'].errors?.['pattern']">
            Password must contain uppercase, lowercase, number and special character
          </div>

          <div *ngIf="f['newPassword'].errors?.['sameAsOld']">
            New password must be different from old password
          </div>
        </div>
      </div>


      <!-- Confirm Password -->
      <div class="form-field">
        <label class="form-label" for="confirmPassword">
          Confirm Password
        </label>

        <div class="input-shell">
          <i class="bi bi-lock-fill input-icon"></i>

          <input id="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmPassword" class="form-control" [ngClass]="{
              'is-invalid': passwordSubmitted && f['confirmPassword'].errors,
              'is-valid': passwordSubmitted && !f['confirmPassword'].errors
            }" placeholder="Confirm new password" autocomplete="new-password" />

          <button type="button" class="password-toggle" (click)="togglePassword('confirm')">
            <i class="bi" [class.bi-eye]="!showConfirmPassword" [class.bi-eye-slash]="showConfirmPassword"></i>
          </button>
        </div>

        <div class="invalid-feedback" [class.d-block]="passwordSubmitted && f['confirmPassword'].errors">
          <div *ngIf="f['confirmPassword'].errors?.['required']">
            Confirm password is required
          </div>

          <div *ngIf="f['confirmPassword'].errors?.['minlength']">
            Minimum 8 characters required
          </div>

          <div *ngIf="f['confirmPassword'].errors?.['passwordMismatch']">
            Passwords do not match
          </div>
        </div>
      </div>
      <button type="submit" class="btn change-password-submit w-100">
        {{ 'Change Password' }}
      </button>
      @if (optional) {
        <button type="button" class="btn change-password-cancel w-100" (click)="cancelled.emit()">Cancel</button>
      }

    </form>

  </div>
</div>